export const Base_Url = process.env.REACT_APP_BASE_URL;
export const lwa_app_id = process.env.REACT_APP_LAW_APP_ID;
export const lwa_client_secret = process.env.REACT_APP_LWA_CLIENT_SERCRET;
export const lwa_application_id = process.env.REACT_APP_LAW_APPLICATION_ID;

export const api_Url = {
  user_login: "/auth/login",
  user_register: "/auth/register"
};
